import EditStopBtn from 'components/orders/OrderSummary/components/OrderStop/components/EditStopBtn/EditStopBtn.styled';

export default EditStopBtn;
